import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

const url = `${AWS_API_URL}/internet-providers`;

export async function getInternetProvidersAPI() {
  return getRequest(url, await authorize());
}
